export const Style = (styleString) => {
    let style = document.createElement('style');
    style.type = 'text/css';
    if (typeof styleString === 'string') {
        try {
            style.appendChild(document.createTextNode(styleString));
        } catch (ex) {
            style.styleSheet.cssText = styleString;
        }
    } else {
        let css = '';
        for (let key in json) {
            css += key + ':' + json[key] + ';';
        }
        try {
            style.appendChild(document.createTextNode(css));
        } catch (ex) {
            style.styleSheet.cssText = css;
        }

    }
    let head = document.getElementsByTagName('head')[0];
    head.appendChild(style);

}